const translations = {
    pt: {
        title: 'Editar Perfil',
        back: 'Voltar',
        saving: 'Salvando…',
        saved: 'Salvo!',
        searchPlaceholder: 'Buscar…',
        noResults: 'Nada encontrado',
        secIdentity: 'Identidade',
        secOccupation: 'Atuação profissional',
        secPreferences: 'Preferências',
        howDoYouWork: 'Como você atua?',
        platformInterestQuestion: 'O que você busca na plataforma?',
        helperOccupation: 'Conte como você se relaciona com o café — isso personaliza sua experiência.',
        helperInterest: 'Nos ajuda a priorizar os temas certos. Opcional.',
        helperResearch: 'Usamos para recomendar conteúdo do seu interesse.',
        helperBiological: 'Indica se você trabalha com bioinsumos/biológicos.',
        personalData: 'Dados Pessoais',
        fullName: 'Nome Completo',
        email: 'Email',
        cpf: 'CPF (opcional)',
        dateOfBirth: 'Data de Nascimento',
        location: 'Localização',
        state: 'Estado',
        selectState: 'Selecione seu estado',
        city: 'Cidade',
        selectCity: 'Selecione sua cidade',
        geoPermission: 'Permissão para coletar dados geográficos',
        occupation: 'Ocupação',
        occupationType: 'Tipo de Ocupação',
        selectOccupation: 'Selecione sua ocupação',
        student: 'Estudante',
        consultant: 'Consultor',
        researcher: 'Pesquisador',
        producer: 'Produtor',
        other: 'Outro',
        cropType: 'Tipo de Cultura',
        plantedArea: 'Área Plantada',
        plantingChallenges: 'Desafios de Plantio',
        educationalInstitution: 'Instituição de Ensino',
        isFarmerChild: 'Filho(a) de produtor rural?',
        yes: 'Sim',
        no: 'Não',
        company: 'Empresa',
        involvedWithBiological: 'Envolvido com uso de biológicos?',
        conductsCoffeeResearch: 'Realiza pesquisa com café?',
        usesBiologicalInResearch: 'Utiliza biológicos em pesquisas?',
        platformInterest: 'Interesses na Plataforma',
        saveChanges: 'Salvar Alterações',
        successMessage: 'Perfil atualizado com sucesso!',
        errorMessage: 'Falha ao atualizar perfil:',
        errorLoading: 'Erro ao carregar dados do usuário:',
        placeholderArea: 'Área em hectares',
        otherDescription: 'Descrição da Ocupação',
        placeholderOtherDescription: 'Descreva sua ocupação',
        changePassword: 'Alterar Senha',
        newPassword: 'Nova Senha',
        confirmNewPassword: 'Confirmar Nova Senha',
        passwordTooShort: 'Senha deve ter pelo menos 8 caracteres',
        passwordNeedUppercase: 'Senha deve conter pelo menos uma letra maiúscula',
        passwordNeedLowercase: 'Senha deve conter pelo menos uma letra minúscula',
        passwordNeedNumber: 'Senha deve conter pelo menos um número',
        passwordMismatch: 'Senhas não coincidem',
        passwordChangedLogout: 'Senha alterada com sucesso! Você será redirecionado para o login.',
        occupationChangeWarning: 'Alterar a ocupação irá apagar todos os dados específicos da ocupação atual. Deseja continuar?',
        confirmChange: 'Confirmar Alteração',
        cancel: 'Cancelar',
        passwordRequired: 'Senha é obrigatória',
        passwordErrorMinLength: 'A senha deve ter pelo menos 8 caracteres',
        passwordErrorUpperCase: 'A senha deve conter pelo menos uma letra maiúscula',
        passwordErrorLowerCase: 'A senha deve conter pelo menos uma letra minúscula',
        passwordErrorNumber: 'A senha deve conter pelo menos um número',
        passwordErrorSpecialChar: 'A senha deve conter pelo menos um caractere especial',
        passwordError: 'Erro na senha',
        passwordErrorConfirm: 'Erro na confirmação da senha',
        passwordErrorMismatch: 'As senhas não coincidem',
        passwordErrorRequired: 'A senha é obrigatória',
        cpfInvalidFormat: 'Formato inválido (XXX.XXX.XXX-XX)',
        cpfInvalid: 'CPF inválido',
        emailInvalid: 'Email inválido',
        selectCropType: 'Selecione o tipo de cultura',
        plantingChallengesPlaceholder: 'Discorra sobre os desafios de plantio que você enfrenta...',
        missingFields: 'Falha. Campos obrigatórios faltando:',
        fieldNames: {
            cropType: 'Tipo de Cultura',
            areaplanted: 'Área Plantada',
            plantingChallengesDescription: 'Desafios de Plantio',
            company: 'Empresa',
            educationalInstitution: 'Instituição de Ensino',
            otherDescription: 'Descrição da Ocupação',
            isInvolvedWithBiological: 'Uso de Biológicos',
            conductsCoffeeResearch: 'Pesquisa em Café'
        },
        platformInterestPlaceholder: 'Descreva seus interesses na plataforma...',
    },
    en: {
        title: 'Edit Profile',
        back: 'Back',
        saving: 'Saving…',
        saved: 'Saved!',
        searchPlaceholder: 'Search…',
        noResults: 'No results',
        secIdentity: 'Identity',
        secOccupation: 'Professional role',
        secPreferences: 'Preferences',
        howDoYouWork: 'How do you work?',
        platformInterestQuestion: 'What are you looking for on the platform?',
        helperOccupation: 'Tell us how you relate to coffee — it personalizes your experience.',
        helperInterest: 'Helps us prioritize the right topics. Optional.',
        helperResearch: 'Used to recommend content that interests you.',
        helperBiological: 'Indicates whether you work with bioinputs/biologicals.',
        personalData: 'Personal Information',
        fullName: 'Full Name',
        email: 'Email',
        cpf: 'CPF (optional)',
        dateOfBirth: 'Date of Birth',
        location: 'Location',
        state: 'State',
        selectState: 'Select your state',
        city: 'City',
        selectCity: 'Select your city',
        geoPermission: 'Permission to collect geographic data',
        occupation: 'Occupation',
        occupationType: 'Occupation Type',
        selectOccupation: 'Select your occupation',
        student: 'Student',
        consultant: 'Consultant',
        researcher: 'Researcher',
        producer: 'Producer',
        other: 'Other',
        cropType: 'Crop Type',
        plantedArea: 'Planted Area',
        plantingChallenges: 'Planting Challenges',
        educationalInstitution: 'Educational Institution',
        isFarmerChild: 'Child of a farmer?',
        yes: 'Yes',
        no: 'No',
        company: 'Company',
        involvedWithBiological: 'Involved with biologicals?',
        conductsCoffeeResearch: 'Conducts coffee research?',
        usesBiologicalInResearch: 'Uses biologicals in research?',
        platformInterest: 'Platform Interests',
        saveChanges: 'Save Changes',
        successMessage: 'Profile updated successfully!',
        errorMessage: 'Failed to update profile:',
        errorLoading: 'Error loading user data:',
        placeholderArea: 'Area in hectares',
        otherDescription: 'Occupation Description',
        placeholderOtherDescription: 'Describe your occupation',
        changePassword: 'Change Password',
        newPassword: 'New Password',
        confirmNewPassword: 'Confirm New Password',
        passwordTooShort: 'Password must be at least 8 characters',
        passwordNeedUppercase: 'Password must contain at least one uppercase letter',
        passwordNeedLowercase: 'Password must contain at least one lowercase letter',
        passwordNeedNumber: 'Password must contain at least one number',
        passwordMismatch: 'Passwords do not match',
        passwordChangedLogout: 'Password changed successfully! You will be redirected to login.',
        occupationChangeWarning: 'Changing occupation will delete all current occupation-specific data. Do you want to continue?',
        confirmChange: 'Confirm Change',
        cancel: 'Cancel',
        passwordRequired: 'Password is required',
        passwordErrorMinLength: 'Password must be at least 8 characters long',
        passwordErrorUpperCase: 'Password must contain at least one uppercase letter',
        passwordErrorLowerCase: 'Password must contain at least one lowercase letter',
        passwordErrorNumber: 'Password must contain at least one number',
        passwordErrorSpecialChar: 'Password must contain at least one special character',
        passwordError: 'Password error',
        passwordErrorConfirm: 'Password confirmation error',
        passwordErrorMismatch: 'Passwords do not match',
        cpfInvalidFormat: 'Invalid format (XXX.XXX.XXX-XX)',
        cpfInvalid: 'Invalid CPF',
        emailInvalid: 'Invalid email',
        selectCropType: 'Select crop type',
        plantingChallengesPlaceholder: 'Describe the planting challenges you face...',
        missingFields: 'Failure. Required fields missing:',
        fieldNames: {
            cropType: 'Crop Type',
            areaplanted: 'Planted Area',
            plantingChallengesDescription: 'Planting Challenges',
            company: 'Company',
            educationalInstitution: 'Educational Institution',
            otherDescription: 'Occupation Description',
            isInvolvedWithBiological: 'Use of Biologicals',
            conductsCoffeeResearch: 'Coffee Research'
        },
        platformInterestPlaceholder: 'Describe your interests in the platform...',
    },
};

export default translations;